import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAmericanairlinesComponent } from './simple-icons-americanairlines.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAmericanairlinesComponent ],
    exports:      [ SimpleIconsAmericanairlinesComponent ],
    bootstrap:    []
})
export class SimpleIconsAmericanairlinesModule {}
